module.exports = __webpack_public_path__ + "img/logo.545a8c94.png";